import React, { Component } from 'react';

const statsData = require('./data/stats_page.json');

class StatsPage extends Component {
    static defaultProps = { s:0 };

    constructor(props){
        super(props);

        this.state = {s:0, focused:null, toolTipIndex:0};
        this.clicked = this.clicked.bind(this);
        this.select = this.select.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        //this.hover = this.hover.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);

        this.data = statsData;
    }

    componentWillMount() {
        window.addEventListener('keydown', this.handleKeyDown);
        this.updateDimensions();
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions() {
        this.forceUpdate();
    }
    

    clicked() {
        this.setState({s:(this.state.s+1)%4});
    }

    select(i) {
        let focused = this.state.focused;
        if (i === 3) {
            focused = false;
        }
        this.setState({s:i, focused:focused});
    }

    scroll() {
        this.setState({focused:false});
    }

    handleKeyDown(e) {
        let newTab = 0;
        let tabs = 3;
        
        switch(e.key) {
        case 'ArrowLeft':
            newTab = (this.state.s - 1 + tabs) % tabs;
            this.setState({s:newTab});
            break;

        case 'ArrowRight':
            newTab = (this.state.s + 1) % tabs;
            this.setState({s:newTab});
            break;

        case 'ArrowUp':
            break;
            
        case 'ArrowDown':
            break;
            
        default:
            break;
        }

    }

    hover(e, i) {
        //let box = e.target.getBoundingClientRect();
        //if (box.top > 265 && box.top < 880) {
            this.setState({focused:e.target, toolTipIndex:i});
        //}
    }

    renderUnselectedTab(text) {
        return (
            <g>
              <path style={{fill:"#9f5937", strokeWidth:0}} d="M6 90 L29 5 L433 5 L456 90 Z" />
              <text fill="#e5b379" fontSize="35" textAnchor="middle" fontWeight="900" x="235" y="65">{text}</text>
            </g>
        );
    }

    renderSelectedTab(text) {
        return (
            <g>
              <path style={{fill:"#ead1b3", strokeWidth:0}} d="M25 0 L437 0 L462 92 L0 92 Z" />
              <path style={{fill:"#e86b21", strokeWidth:0}} d="M94 5 L368 5 L395 96 L69 96 Z" />
              <text fill="#ead1b3" fontSize="50" textAnchor="middle" fontWeight="900" x="230" y="75">{text}</text>
            </g>
        );
    }

    renderStatElement(i) {
        let outline = 6;
        let translate = "translate(0, " + (i*64) + ")";
        return (
            <g>
              <rect fill="#8b4f2b" x="110" y={i*64} width="1688" height="70"></rect>
              <rect fill="#dddfde" rx="7" ry="7" x={110+outline} y={i*64+outline} width={1688-outline*2} height={70-outline*2}></rect>
              <g transform={translate}>
                <path style={{fill:"#c46b30", strokeWidth:0}} d="M1315 6 L1795 6 L1795 64 L1275 64 Z" />
              </g>
              <text className="stat-name" x={215} y={i*64-15}>This is a test</text>
              <text className="stat-value" x={1920-215} y={i*64-15}>3000</text>
            </g>
        );
    }

    render() {
        const listData = [["Battles", "battles", "Number of battles fought for glory."],
                          ["Victories", "victories", "Number of victories in battles fought for glory."],
                          ["Win Rate", "win_rate", "Percentage won of battles fought for glory."],
                          ["Win Rate (Last 10)", "win_rate_10", "Percentage won of the last 10 battles fought for glory."],
                          ["Win Rate (Last 50)", "win_rate_50", "Percentage won of the last 50 battles fought for glory."],
                          ["Win Rate (Last 100)", "win_rate_100", "Percentage won of the last 100 battles fought for glory."],
                          ["Total KOs", "total_kills", "Number of times you've knocked out opponents in battles fought for glory."],
                          ["Average KOs", "average_kills", "Average number of KOs you've dealt out per battle."],
                          ["Total Falls", "total_falls", "Number of times you've been KO'd or have self-destructed... for glory."],
                          ["Average Falls", "average_falls", "Average number of times you've been KO'd or have self-destructed per battle."],
                          ["Play Time", "play_time", "Total amount of time spent fighting battles for glory."],
                          ["Damage Given", "damage_given", "Total amount of damage dealt to opponents."],
                          ["Damage Taken", "damage_taken", "Total amount of damage received from opponents."],
                          ["Average Damage Given", "average_damage_given", "Average amount of damage dealt in a battle for glory."],
                          ["Average Damage Taken", "average_damage_taken", "Average amount of damage taken in a battle for glory."],
                          ["Sudden Deaths", "sudden_deaths", "Number of times you've taken part in a Sudden Death showdown."],
                          ["Sudden Death Win Rate", "sudden_death_win_rate", "Number of times you've emerged victorious in Sudden Death."],
                          ["Sudden Death Tournament Win Rate", "sudden_death_tournament_win_rate", ""],
                          ["Disconnects", "disconnects", "Number of times you've been disconnected."]];

        const tabs = ["Combined", "Team", "1-on-1", "About"];
        const filters = ["both", "2v2", "1v1", ""];
        const offset = 370;
        const startx = 182;
        const starty = 45;

        const divide = (<path style={{stroke:"#262828", strokeWidth:6}} d="M433 5 L456 90" />);

        const footer = (
            <svg className="StatsPage-footer" width="100%" viewBox="0 0 1920 100">
              <rect style={{fill:"#262828", strokeWidth:0}} x="0 " y="0" width="100%" height="3" />
              <rect style={{fill:"#b4b5b0", strokeWidth:0}} x="0 " y="3" width="100%" height="63" />
              <rect style={{fill:"#d8610e", strokeWidth:0}} x="0 " y="63" width="100%" height="9" />
              <g transform="translate(0, 28)">
                <path style={{stroke:"#262828", strokeWidth:0}} d="M0 0 L122 0 L166 44 L1920 44 L1920 77 L0 77 Z" />
              </g>
              <text className="StatsPage-description" x="230" y="48">{listData[this.state.toolTipIndex][2]}</text>
            </svg>
        );

        let focused = [false, false, false];
        focused[this.state.s] = true;


        let rect = [0, 0, 0, 0];
        if(this.state.focused) {
            const box = this.state.focused.getBoundingClientRect();
            rect = [box.left-7, window.scrollY + box.top - 10, box.width - 10, box.height-10];
            
        }
        const focusDiv = <div className="StatsPage-focused" style={{left:rect[0], top: rect[1], width:rect[2], height:rect[3]}}/>;

        let statsList;
        if (this.state.s !== 3) {
            statsList = (
                <ul className="StatsPage-list" onScroll={() => this.scroll()}>
                  {
                      listData.map(function(value, i)  {
                          let filter = filters[this.state.s];
                          let stat = value[1] in this.data[filter] ? this.data[filter][value[1]] : "NA";
                          return <li key={"line"+i} onMouseOver={(e) => this.hover(e, i)}><span className="left">{value[0]}</span><span className="right">{stat}</span><br/></li>;
                      }, this)
                  }
                </ul>
            );
        } else {
            statsList = null;
        }
        
        return (
            <div className="StatsPage">
              <svg className="stats-header" width="100%" viewBox="0 0 1920 199">
                <rect style={{fill:"#262828", strokeWidth:0}} x={0} y={0} width="100%" height={143} />
                <rect style={{fill:"#e76a20", strokeWidth:0}} x={0} y={140} width="100%" height={30} />
                <rect style={{fill:"#ead1b3", strokeWidth:0}} x={0} y={135} width="100%" height={5} />
                {
                    focused.map(function(value, i) {
                        let pos = "translate(" + (startx + i*offset) + ", " + starty + ")";
                        return <g key={"tab"+i} transform={pos} onClick={(e) => this.select(i)}>{value ? null : this.renderUnselectedTab(tabs[i])}</g>;
                    }, this)
                }
                {
                    focused.map(function(value, i) {
                        let pos = "translate(" + (startx + i*offset) + ", " + starty + ")";
                        return <g key={"divide"+i} transform={pos}>{divide}</g>;
                    })
                }
                {
                    focused.map(function(value, i) {
                        let pos = "translate(" + (startx + i*offset) + ", " + starty + ")";
                        return <g key={"stab"+i} transform={pos}>{value ? this.renderSelectedTab(tabs[i]) : null}</g>;
                    }, this)
                }
                {/*<g transform="translate(0, 269)">
                  {
                      listData.map(function(value, i) {
                          return this.renderStatElement(i);
                      }, this)
                  }
                </g>*/}
              </svg>
              
              
              { this.state.focused &&
                  focusDiv
              }

              { statsList }


              {footer}
            </div>
        );
    }
}

export default StatsPage;

